import { fonts } from '$tablet-app/src/app/theme';
import React from 'react';
import { StyleSheet } from 'react-native';
import MarkdownRenderer, { MarkdownProps } from 'react-native-markdown-display';

const Markdown = (props: MarkdownProps) => (
  <MarkdownRenderer style={styles} {...props} />
);

const styles = StyleSheet.create({
  body: {
    fontFamily: fonts.regular,
    fontSize: 17,
    lineHeight: 25,
  },
});

export default Markdown;
